import { defaults } from "react-chartjs-2";
defaults.global.elements.point.radius = 4;
